export default __webpack_public_path__ + "static/media/2k_eris_fictional.1af2d315.png";